import { LifeBuoy } from 'lucide-react'
import { useState } from 'react'

import MemberOnboardingSupportPopoverContent from './MemberOnboardingSupportContent'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from './ui/popover'

const MemberOnboardingSupportPopover = () => {
  const [open, setOpen] = useState(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger onClick={() => setOpen(true)} className='flex space-x-1 sm:space-x-2 items-center body text-gray-800 hover:text-thatch-600 transition'>
        <LifeBuoy size={20} /><span>Help & support</span>
      </PopoverTrigger>
      <PopoverContent align='start' className='w-96 p-4'>
        <MemberOnboardingSupportPopoverContent onDismiss={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}

export default MemberOnboardingSupportPopover
